/**
 * APP main.
 */

import React, { Component } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

//import main page
import Main from './component/main'
import Header from './component/header';
import Footer from './component/footer';
import Terms from './component/policies/terms';
import Privacy from './component/policies/privacy';
import Util from './utils'
import LoadingLayer from "./component/common/loadingLayer";

import jsonMenu from './data/menu.json'

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';

class App extends Component{
    constructor(props){
        super(props)

        var self = this;
        this.state = {
            menu : jsonMenu
            ,active : null
            ,currentPage : ''
            ,addPath : '/'
            ,ver : '1.0'
            ,isLoading: true
        };

        // this.props.history.listen((location, action) => {
        //     console.log("on route change", location, action, this.props.title);
        //
        //     this.setActive(location);
        // });

        this.setActive.bind(this);

    }

    loadingFinished(){
        this.setState({isLoading: false})
    }

    setActive(location){
        console.log('setActive', location)
        //set title
        let _id, active = null, curpage = '';
        switch(location.pathname){
            case '/':
                this.setState({currentPage : ''});
                switch(location.hash){
                    // case '#'+this.state.menu[0].code:   //about
                    //     _id = this.state.menu[0].code;
                    //     active = 0;
                    //     break;
                    default:
                        break;
                }
                break;
            case '/portfolio':
                _id = curpage = 'portfolio';
                active = 4;
                break;
            case '/career':
                _id = 'career';
                break;
            default:

                break;
        }

        this.setState({
            currentPage : curpage,
            active : active
        }, () => {
            // Utils.scrollSpy({
            //     navWrapper : '#top-head',
            //     menuClass : '.nav-link',      //element that has href attributes to track
            //     activeClass : 'on',
            //     active : this.state.active,
            //     spyOn : '#index'
            // });
        });

    }

    componentDidMount(){

        this.setActive(window.location);

    }

    render() {

        return (
            <div>
                <Header menu={this.state.menu} active={this.state.active}/>
                {/*Routing*/}
                <main className="index" id="index">
                    <Switch>
                        <Route exact path={'/'} name="main" render={(props) => <Main setLoadingFinished={this.loadingFinished.bind(this)} />} />
                        <Route exact path={'/terms/'} name="terms" render={(props) => <Terms setLoadingFinished={this.loadingFinished.bind(this)} />} />
                        <Route exact path={'/privacy/'} name="privacy" render={(props) => <Privacy setLoadingFinished={this.loadingFinished.bind(this)} />} />
                        {/*<Route exact path={'/privacy-policy'} name="privacy" component={Privacy} />*/}
                        <Redirect to="/" />
                    </Switch>
                </main>
                <Footer ver={this.state.ver} addPath={this.state.addPath}/>
                <LoadingLayer id="loading" size={60} active={this.state.isLoading}/>
            </div>
        )
    }
}

//export default App;
export default withRouter(connect(null, null)(App));


// WEBPACK FOOTER //
// ./src/app.js